export default {"src":"/_next/static/media/hiking.90269641.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};